import { proxy } from 'valtio';

export const environmentState = proxy({
  apiUrl: '',
  paypalClientId: '',
  countryCode: '',
});

/**
 * Initialize the shared environment state
 */
export function initializeEnvironment(config: {
  apiUrl: string;
  paypalClientId: string;
  countryCode: string;
}) {
  environmentState.apiUrl = config.apiUrl;
  environmentState.paypalClientId = config.paypalClientId;
  environmentState.countryCode = config.countryCode;
}
